import { Button } from "@components/controls/Button"
import { ChipList } from "@components/layout/ChipList"
import { ResultListMode } from "@components/layout/ResultList"
import { RouteFlippedResponsiveImage } from "@components/motion/RouteFlipped"
import { IconCaretRight } from "@components/svg/Icons"
import { simpleDate } from "@utils/dates"
import { Link } from "eddev/routing"
import { ReactNode } from "react"
import { ArticleCardFragment } from "../../types.graphql"

type Props = ArticleCardFragment & {
  mode?: ResultListMode
}

export function ArticleCard(props: Props) {
  const meta = [] as ReactNode[]

  if (props.date) meta.push(<span key="date">{simpleDate(props.date)}</span>)
  if (props.memberAuthor?.name) meta.push(<span key="author">{props.memberAuthor?.name}</span>)

  if (props.mode === "row") {
    return (
      <Link href={props.uri} className="grid-auto @container grid-flow-col border-t pt-4 pb-4 text-pretty">
        <div className="col-span-3 order-1 @xl:order-none @xl:col-span-1">
          <RouteFlippedResponsiveImage flipId={props.id!} {...props.hero?.image!} aspect={5 / 3} />
        </div>
        <div className="col-span-9 @xl:col-span-4">
          <div className="type-title-xs-medium @xl:type-title-s-medium antialiased">{props.title}</div>
          <div className="type-body-s-roman text-grey whitespace-nowrap flex flex-wrap my-2 @xl:my-1 gap-x-3">{meta}</div>
          <div className="flex flex-wrap gap-1 pt-1">
            <ChipList chips={props.chips!} noLinks />
          </div>
        </div>
        <div className="hidden @xl:block @xl:col-span-5">
          <div className="type-body-s-roman line-clamp-3">{props.shortDescription}</div>
        </div>
        <div className="hidden @xl:flex justify-end @xl:col-span-2">
          <Button variant="outline" rightIcon={<IconCaretRight />}>
            Read More
          </Button>
        </div>
      </Link>
    )
  } else {
    return (
      <Link href={props.uri} className="block mb-7 group">
        <RouteFlippedResponsiveImage flipId={props.id!} {...props.hero?.image!} aspect={5 / 3} />
        <div className="stack-y gap-3 md:gap-1 pt-3 md:pt-2">
          {!!meta.length && <div className="flex flex-wrap type-ui-s-roman text-grey gap-x-3 gap-y-1">{meta}</div>}
          <div className="stack-y">
            <div className="type-title-s-medium antialiased text-pretty group-hover:text-grey-dark">{props.title}</div>
            {!!props.subtitle && <div className="type-title-s-light antialiased text-pretty">{props.subtitle}</div>}
          </div>
          <ChipList chips={props.chips!} noLinks />
          <div className="pt-1 type-body-s-roman line-clamp-2">{props.shortDescription}</div>
        </div>
      </Link>
    )
  }
}
